<script lang="ts">
  import { updateItem, deleteItem } from "../stores/data";
  import type { GroceryItem } from "../types";

  let { item }: { item: GroceryItem } = $props();

  // Populated from `item` by openEdit() right before the form is shown, not
  // wired up as derived state — this is an editable draft, not a mirror.
  let expanded = $state(false);
  let editName = $state("");
  let editQuantity = $state("");
  let editUnit = $state("");

  function toggle(): void {
    void updateItem(item.id, { checked: !item.checked });
  }

  function openEdit(event: MouseEvent): void {
    event.stopPropagation();
    editName = item.name;
    editQuantity = item.quantity !== null ? String(item.quantity) : "";
    editUnit = item.unit ?? "";
    expanded = !expanded;
  }

  function saveEdit(event: SubmitEvent): void {
    event.preventDefault();
    const trimmed = editName.trim();
    if (!trimmed) return;
    const parsedQuantity = editQuantity.trim() ? Number(editQuantity) : null;
    void updateItem(item.id, {
      name: trimmed,
      quantity: parsedQuantity !== null && Number.isFinite(parsedQuantity) ? parsedQuantity : null,
      unit: editUnit.trim() || null,
    });
    expanded = false;
  }

  function remove(event: MouseEvent): void {
    event.stopPropagation();
    if (confirm(`Delete "${item.name}"?`)) {
      void deleteItem(item.id);
    }
  }
</script>

<li class="item">
  <button class="row" class:checked={item.checked} onclick={toggle} type="button">
    <span class="checkbox" aria-hidden="true">{item.checked ? "✓" : ""}</span>
    <span class="name">{item.name}</span>
    {#if item.quantity !== null || item.unit}
      <span class="qty">{item.quantity ?? ""} {item.unit ?? ""}</span>
    {/if}
  </button>
  <button class="icon-btn" aria-label="Edit item" onclick={openEdit} type="button">✎</button>
  <button class="icon-btn" aria-label="Delete item" onclick={remove} type="button">🗑</button>

  {#if expanded}
    <form class="edit-form" onsubmit={saveEdit}>
      <input class="field-name" type="text" bind:value={editName} maxlength="200" placeholder="Name" />
      <input type="text" inputmode="decimal" bind:value={editQuantity} placeholder="Qty" />
      <input type="text" bind:value={editUnit} placeholder="Unit" maxlength="32" />
      <button class="save-btn" type="submit">Save</button>
    </form>
  {/if}
</li>

<style>
  .item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    border-bottom: 1px solid var(--border);
  }
  .row {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.9rem 0.5rem;
    background: none;
    border: none;
    text-align: left;
    cursor: pointer;
    color: var(--text);
    min-width: 0;
  }
  .checkbox {
    flex: 0 0 auto;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    border: 2px solid var(--accent);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--accent-contrast);
    font-size: 0.9rem;
  }
  .row.checked .checkbox {
    background: var(--accent);
  }
  .name {
    flex: 1;
    min-width: 0;
    overflow-wrap: anywhere;
  }
  .row.checked .name {
    text-decoration: line-through;
    color: var(--text-muted);
  }
  .qty {
    flex: 0 0 auto;
    color: var(--text-muted);
    font-size: 0.9rem;
  }
  .icon-btn {
    flex: 0 0 auto;
    background: none;
    border: none;
    font-size: 1.1rem;
    padding: 0.6rem;
    cursor: pointer;
    color: var(--text-muted);
  }
  .edit-form {
    flex-basis: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr auto;
    gap: 0.5rem;
    padding: 0 0.5rem 0.75rem;
  }
  .edit-form .field-name {
    grid-column: 1 / -1;
  }
  .edit-form input {
    min-width: 0;
    padding: 0.6rem;
    border-radius: var(--radius);
    border: 1px solid var(--border);
    background: var(--bg);
    color: var(--text);
  }
  .edit-form .save-btn {
    border: none;
    border-radius: var(--radius);
    background: var(--accent);
    color: var(--accent-contrast);
    padding: 0 1rem;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
  }
</style>
